<mat-toolbar class="titulopartes">Documentos</mat-toolbar>
<!-- Apresenta CPF -->
<div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill *ngIf="apresentaCPF">
    <!-- CPF -->
    <mat-form-field fxFlexOffset="20px" fxFlex="30%">
        <input matInput
               [(ngModel)]="pessoaFisica.cpf"
               name="cpf"
               placeholder="CPF:"
               [textMask]="{mask: mascaraCpf}"
               [cpfValidator]
               *ngIf="!validaCPF">

        <input matInput
               [(ngModel)]="pessoaFisica.cpf"
               name="cpf"
               placeholder="CPF:"
               [textMask]="{mask: mascaraCpf}"
               [cpfValidator]
               [required]=validaCPF
               *ngIf="validaCPF">

         <mat-error >Informa apenas valores numéricos</mat-error>
    </mat-form-field>

    <!-- NIS -->
    <mat-form-field fxFlex="30%">
        <input matInput [(ngModel)]="pessoaFisica.nis" name="NIS" placeholder="NIS" [textMask]="{mask: mascaraNIS}">
    </mat-form-field>
</div>

<div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <mat-form-field fxFlexOffset="20px" fxFlex="30%">
        <input matInput maxlength="30" [(ngModel)]="pessoaFisica.identidade" name="identidade" placeholder="Identidade">
    </mat-form-field>

    <mat-form-field fxFlex="30%">
        <input matInput [(ngModel)]="pessoaFisica.orgaoCi" name="orgaoCi" maxlength="45" placeholder="Órgão Expedidor">
    </mat-form-field>

    <combo-uf fxFlex="5%"
              [selecionado]="pessoaFisica.ufCi"
              [obrigatorio]="false"
              (valorChange)="onUfCiChange($event)">
    </combo-uf>

    <mat-form-field fxFlex="22%">
        <input matInput name="dataEmissaoCI" [matDatepicker]="dataEmissaoCI"
               placeholder="Data de Emissão"
               (input)="onMascaraDataInput($event)"
               [(ngModel)]="pessoaFisica.dataEmissaoCI">
        <mat-datepicker-toggle matSuffix [for]="dataEmissaoCI"></mat-datepicker-toggle>
        <mat-datepicker #dataEmissaoCI></mat-datepicker>
    </mat-form-field>
</div>

<!-- Não apresenta CPF -->
<div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill *ngIf="!apresentaCPF">
    <!-- NIS -->
    <mat-form-field fxFlexOffset="20px" fxFlex="30%">
        <input matInput [(ngModel)]="pessoaFisica.nis" name="NIS" placeholder="NIS" [textMask]="{mask: mascaraNIS}">
    </mat-form-field>
</div>
